import React, { Component } from 'react';
import * as Styles from './Styles';

type Props = {};

type State = {};

class Footer extends Component<Props, State> {
	state = {};

	render() {
		return (
			<Styles.FooterWrapper>
				<Styles.FooterGenericFont>
					Jeśli masz jakiekolwiek pytania lub potrzebujesz dodatkowej
					pomocy, nasz zespół jest gotowy, aby Cię wesprzeć.
					Skontaktuj się z nami:
				</Styles.FooterGenericFont>
				<Styles.FooterGenericFont>
					Michał Olejnik{' '}
					<a href="tel:+48 56 669 33 07">
						<span>(+48 56 669 33 07)</span>
					</a>{' '}
					lub Róża Błaś{' '}
					<a href="tel:+48 56 669 32 16">
						<span>(+48 56 669 32 16)</span>
					</a>
				</Styles.FooterGenericFont>
				<Styles.FooterGenericFont style={{ marginTop: '12px' }}>
					Pracujemy od poniedziałku do piątku w godzinach 8:00 -
					16:00.
				</Styles.FooterGenericFont>
			</Styles.FooterWrapper>
		);
	}
}

export default Footer;
